<template>
  <div>
    <a-tabs default-active-key="1" @change="tabChange">
      <a-tab-pane key="1" tab="当班日志">
        <OperationRecord></OperationRecord>
      </a-tab-pane>
      <a-tab-pane key="2" tab="交接班记录">
        <YwDutyRecord></YwDutyRecord>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import YwDutyRecord from './tabPage.vue'
import OperationRecord from './modules/OperatorRecordForm.vue'
export default {
  name: 'YwDutyRecordList',
  components: {
    YwDutyRecord,
    OperationRecord
  },
  // 定义属性
  data() {
    return {}
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {
    ...mapGetters([''])
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {
    tabChange() {}
  }
}
</script>

<style lang="scss" scoped>

</style>
